// extracted by mini-css-extract-plugin
module.exports = {"container":"_1b_10XljNULS5DuIlWK33c","heading":"h5y6ei0NLKDQ_ae8p7_PI","field":"FOCNNED3bK03r7snbFq_1","icon":"_2PVKN6H2ZcLf7IrrYbo5i_"};